import { render, staticRenderFns } from "./new-ordinary-order.pug?vue&type=template&id=6c09d926&lang=pug&"
import script from "./new-ordinary-order.ts?vue&type=script&lang=ts&"
export * from "./new-ordinary-order.ts?vue&type=script&lang=ts&"
import style0 from "./new-ordinary-order.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports